import React, { FC } from 'react';

import { useRefinementList } from 'react-instantsearch';

import RefinementListView from '~/pages/DiscoverPage/components/RefinementList/RefinementListView';
import { DURATION_FILTER, DURATION_FILTER_ORDER } from '~/pages/DiscoverPage/const';

interface RefinementListProps {
  showMore?: boolean;
  hidden?: boolean;
  attribute: string;
  searchable?: boolean;
  delay?: number;
  limit?: number;
  collapseLimit?: number;
  showMoreLimit?: number;
  loading?: boolean;
  loadingItems?: number;
  translations?: {
    [key: string]: string;
  };
}

export const RefinementList: FC<RefinementListProps> = ({
  showMore = false,
  limit,
  collapseLimit,
  attribute,
  searchable = false,
  delay = 0,
  hidden = false,
  showMoreLimit,
  loading = false,
  loadingItems = 5,
  translations,
}) => {
  const { items, refine, searchForItems, isFromSearch } = useRefinementList({
    attribute: attribute,
    showMoreLimit,
    limit,
  });

  const itemsToShow = showMore && collapseLimit ? collapseLimit : items.length;

  const filtersToShow =
    attribute !== DURATION_FILTER
      ? items
      : // @ts-ignore
        items.sort((a, b) => {
          const aIndex = DURATION_FILTER_ORDER.indexOf(a?.label);
          const bIndex = DURATION_FILTER_ORDER.indexOf(b?.label);
          return (a.isRefined && aIndex - bIndex) || b.isRefined || aIndex - bIndex;
        });

  return !hidden ? (
    <RefinementListView
      showMore={showMore}
      attribute={attribute}
      searchable={searchable}
      searchForItems={searchForItems}
      isFromSearch={isFromSearch}
      loading={loading}
      loadingItems={loadingItems}
      delay={delay}
      items={filtersToShow}
      itemsToShowCount={itemsToShow}
      refine={refine}
      translations={translations}
    />
  ) : (
    <></>
  );
};

export default RefinementList;
